export default __webpack_public_path__ + "static/media/nutri1.19a32304.jpg";